<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>افزودن جزییات تعرفه</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.fee_fa.val" :description="form.fee_fa.inv" label="تعرفه فارسی (ریال)" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.fee_en.val" :description="form.fee_en.inv" label="تعرفه انگلیسی (ریال)" />
                                </CCol>
                                <CCol sm="3">
                                    <label>اپراتور</label>
                                    <model-select :options="operators" v-model="form.mobile_operator_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.mobile_operator_id.inv}}</small>
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> افزودن</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
				fee_fa: {val: '', inv: '', v: { req: true, max: 64 }},
                fee_en: {val: '', inv: '', v: { req: true, max: 64 }},
                mobile_operator_id: {val: '', inv: '', v: { req: true, max: 8 }},
			},
            disable: false,
            operators: [],
        }
    },
    mounted(){
        this.get_operators();
    },
    methods: {
        get_operators(){
            this.axios.get('mobile_operators/')
            .then(res => {
                res.data.map(val => {
                    this.users.push({value: val.id, text: val.name})
                });
            })
        },
        submit(){
            if(this.disable == false){
                const data = new FormData();
                for (const key in this.form){
                    data.set(key, this.form[key].val);
                }
                this.axios.post('operators_fee_info/', data)
                    .then(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'افزودن با موفقیت انجام شد.'
                        });
                        for (const key in this.form){
                            this.form[key].val = '';
                        }
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })
            }
        }
    },
	beforeCreate(){
        if(this.$store.state.perms.can_add_mobile_operators_fee_info == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>
